(function () {
  'use strict';

  function normalizeName(value) {
    var cleaned = value.toUpperCase().replace(/[^A-Z ]/g, '').replace(/\s+/g, ' ');
    var result = '';
    var letters = 0;

    for (var index = 0; index < cleaned.length; index += 1) {
      var character = cleaned[index];

      if (character === ' ') {
        if (result && result[result.length - 1] !== ' ') result += character;
      } else if (letters < 9) {
        result += character;
        letters += 1;
      }
    }

    return result.replace(/^\s+/, '');
  }

  function checkedValue(container, selector) {
    var selected = container.querySelector(selector + ':checked');
    return selected ? selected.value : '';
  }

  function setPersonalizationState(container, active) {
    var form = container.closest('form[action*="/cart/add"]');
    var fields = container.querySelector('[data-shaya-personalization-fields]');
    var quantity = form ? form.querySelector('[name="quantity"]') : null;

    container.classList.toggle('is-active', active);
    fields.hidden = !active;

    if (form) form.classList.toggle('shaya-personalization-active', active);
    if (quantity && active) quantity.value = '1';
  }

  function showError(container, message) {
    var error = container.querySelector('[data-shaya-personalization-error]');
    error.textContent = message;
    error.hidden = false;
    error.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function clearError(container) {
    var error = container.querySelector('[data-shaya-personalization-error]');
    error.textContent = '';
    error.hidden = true;
  }

  function getSelections(container) {
    var nameInput = container.querySelector('[data-shaya-name]');
    var name = normalizeName(nameInput.value).trim();
    nameInput.value = name;

    return {
      name: name,
      color: checkedValue(container, '[data-shaya-color]'),
      font: checkedValue(container, '[data-shaya-font]'),
      location: checkedValue(container, '[data-shaya-location]'),
      emoji: checkedValue(container, '[data-shaya-emoji]'),
      confirmed: container.querySelector('[data-shaya-confirmation]').checked
    };
  }

  function validateSelections(container, selections) {
    if (!selections.name) return 'Enter your pet\'s name.';
    if (!/^[A-Z ]+$/.test(selections.name) || selections.name.replace(/ /g, '').length > 9) {
      return 'Use letters and spaces only, with no more than 9 letters.';
    }
    if (!selections.color) return 'Choose an embroidery color.';
    if (!selections.font) return 'Choose an embroidery font.';
    if (!selections.location) return 'Choose one location on the sweater.';
    if (!selections.confirmed) return 'Confirm the spelling, final-sale policy, and production time.';
    return '';
  }

  function emojiVariant(container, emoji) {
    if (!emoji) return '';
    return container.getAttribute('data-emoji-' + emoji.toLowerCase() + '-variant') || '';
  }

  function selectedVariantTitle(container, variantId) {
    var variantData = container.querySelector('[data-shaya-variant-data]');
    if (!variantData) return '';

    try {
      var variants = JSON.parse(variantData.textContent);
      var selectedVariant = variants.find(function (variant) {
        return Number(variant.id) === Number(variantId);
      });

      if (!selectedVariant || selectedVariant.title === 'Default Title') return '';
      return selectedVariant.title;
    } catch (error) {
      return '';
    }
  }

  function personalizationReference(container, variantId) {
    var productTitle = container.getAttribute('data-product-title') || 'Sweater';
    var variantTitle = selectedVariantTitle(container, variantId);
    return [productTitle, variantTitle].filter(Boolean).join(' / ');
  }

  async function addPersonalizedProduct(form, container, submitButton) {
    clearError(container);

    var selections = getSelections(container);
    var validationMessage = validateSelections(container, selections);

    if (validationMessage) {
      showError(container, validationMessage);
      return;
    }

    var formData = new FormData(form);
    var parentVariantId = Number(formData.get('id'));
    var personalizationVariantId = Number(container.getAttribute('data-personalization-variant'));
    var selectedEmojiVariantId = Number(emojiVariant(container, selections.emoji));
    var groupId = 'shaya-' + Date.now() + '-' + Math.random().toString(36).slice(2, 9);

    if (!parentVariantId || !personalizationVariantId) {
      showError(container, 'Personalization could not be added. Please refresh the page and try again.');
      return;
    }

    var reference = personalizationReference(container, parentVariantId);

    var parentProperties = {
      _shaya_group: groupId,
      _shaya_personalized: 'true'
    };

    var personalizationProperties = {
      'Applies to': reference,
      Name: selections.name,
      'Embroidery Color': selections.color,
      'Embroidery Font': selections.font,
      'Location on Sweater': selections.location,
      'Final Sale Confirmed': 'Yes',
      'Production Time': 'Up to two weeks before shipping',
      _shaya_group: groupId,
      _shaya_add_on: 'personalization'
    };

    var items = [
      {
        id: parentVariantId,
        quantity: 1,
        properties: parentProperties
      },
      {
        id: personalizationVariantId,
        quantity: 1,
        parent_id: parentVariantId,
        properties: personalizationProperties
      }
    ];

    if (selections.emoji && selectedEmojiVariantId) {
      items.push({
        id: selectedEmojiVariantId,
        quantity: 1,
        parent_id: parentVariantId,
        properties: {
          Emoji: selections.emoji,
          'Embroidery Color': selections.color,
          _shaya_group: groupId,
          _shaya_add_on: 'emoji'
        }
      });
    }

    submitButton.setAttribute('disabled', 'disabled');
    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    try {
      var response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ items: items })
      });

      var content = await response.json();
      if (!response.ok) throw new Error(content.description || 'Personalization could not be added.');

      submitButton.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: { variant: { id: parentVariantId }, quantity: 1 }
      }));

      form.reset();
      setPersonalizationState(container, false);
      container.querySelector('[data-shaya-name-count]').textContent = '0/9 letters';
    } catch (error) {
      showError(container, error.message || 'Personalization could not be added. Please try again.');
    } finally {
      submitButton.removeAttribute('disabled');
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
    }
  }

  async function removePersonalization(button) {
    var groupId = button.getAttribute('data-shaya-group');
    if (!groupId) return;

    button.setAttribute('disabled', 'disabled');
    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    try {
      var cartResponse = await fetch(window.Shopify.routes.root + 'cart.js', { credentials: 'same-origin' });
      var cart = await cartResponse.json();
      var groupItems = cart.items.filter(function (item) {
        return item.properties && item.properties._shaya_group === groupId;
      });

      groupItems.sort(function (first, second) {
        var firstIsAddOn = first.properties && first.properties._shaya_add_on ? 0 : 1;
        var secondIsAddOn = second.properties && second.properties._shaya_add_on ? 0 : 1;
        return firstIsAddOn - secondIsAddOn;
      });

      for (var index = 0; index < groupItems.length; index += 1) {
        var removeResponse = await fetch(window.Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ id: groupItems[index].key, quantity: 0 })
        });
        if (!removeResponse.ok) throw new Error('Personalization could not be removed.');
      }

      if (window.location.pathname === '/cart') {
        window.location.reload();
      } else {
        var cartDrawer = document.getElementById('sidebar-cart');
        if (cartDrawer) {
          cartDrawer.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        } else {
          window.location.reload();
        }
      }
    } catch (error) {
      button.removeAttribute('disabled');
      window.alert(error.message || 'Personalization could not be removed. Please try again.');
    } finally {
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
    }
  }

  document.addEventListener('input', function (event) {
    var nameInput = event.target.closest('[data-shaya-name]');
    if (!nameInput) return;

    var normalized = normalizeName(nameInput.value);
    nameInput.value = normalized;
    var container = nameInput.closest('[data-shaya-personalization]');
    container.querySelector('[data-shaya-name-count]').textContent = normalized.replace(/ /g, '').length + '/9 letters';
    clearError(container);
  });

  document.addEventListener('change', function (event) {
    var toggle = event.target.closest('[data-shaya-personalization-toggle]');
    if (toggle) {
      setPersonalizationState(toggle.closest('[data-shaya-personalization]'), toggle.checked);
      return;
    }

    var container = event.target.closest('[data-shaya-personalization]');
    if (container) clearError(container);
  });

  document.addEventListener('click', function (event) {
    var removeButton = event.target.closest('[data-shaya-remove-personalization]');
    if (removeButton) {
      event.preventDefault();
      event.stopImmediatePropagation();
      removePersonalization(removeButton);
      return;
    }

    var submitButton = event.target.closest('button[type="submit"][data-action="add-to-cart"]');
    if (!submitButton) return;

    var form = submitButton.closest('form[action*="/cart/add"]');
    var container = form ? form.querySelector('[data-shaya-personalization]') : null;
    var toggle = container ? container.querySelector('[data-shaya-personalization-toggle]') : null;
    if (!container || !toggle || !toggle.checked) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    addPersonalizedProduct(form, container, submitButton);
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('form[action*="/cart/add"]');
    var container = form ? form.querySelector('[data-shaya-personalization]') : null;
    var toggle = container ? container.querySelector('[data-shaya-personalization-toggle]') : null;
    if (!container || !toggle || !toggle.checked) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    var submitButton = form.querySelector('button[type="submit"][data-action="add-to-cart"]');
    if (submitButton) addPersonalizedProduct(form, container, submitButton);
  }, true);
})();
